module.exports = "/_next/static/images/7-1-6a06e1c8bc552fe87a399f61cd01c0c6.svg";